import { render, staticRenderFns } from "./MRList.vue?vue&type=template&id=73e66a2f"
import script from "./MRList.vue?vue&type=script&lang=ts"
export * from "./MRList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports